import format from "date-fns/format";
import isValid from "date-fns/isValid";
import parseISO from "date-fns/parseISO";
import { getCookie } from "Shared/util/cookies";

const replaceWithNonBreakingHyphens = (text) =>
    !text ? text : text.replace(/-/g, "\u2011");

const defaultLanguageSwitch = (cult) => {
    switch (cult) {
        case "SE":
            return "sv";
        case "FI":
            return "fi";
        case "GB":
            return "en";
        default:
            return "none";
    }
};

const currencyFormatter = (amount, decimals) => {
    const country = getCookie("App.CultureCode");
    const defaultLanguage = defaultLanguageSwitch(country.toUpperCase());
    const a = Intl.NumberFormat(`${defaultLanguage}-${country}`, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(amount || 0);
    return a;
};

export const getYearAndMonth = (yearAndMonth) => {
    const country = getCookie("App.CultureCode");
    let year;
    let month;
    switch (country.toLowerCase()) {
        case "se":
            year = parseInt(yearAndMonth.split("-")[0], 10);
            month = parseInt(yearAndMonth.split("-")[1], 10);
            break;
        case "fi":
            year = parseInt(yearAndMonth.split(".")[1], 10);
            month = parseInt(yearAndMonth.split(".")[0], 10);
            break;
        case "gb":
            year = parseInt(yearAndMonth.split("/")[0], 10);
            month = parseInt(yearAndMonth.split("/")[1], 10);
            break;
        default:
            throw new Error(`Invalid country ${country}`);
    }
    return [year, month];
};

export const getDateFormat = () => {
    let df;
    const country = getCookie("App.CultureCode");
    switch (country.toLowerCase()) {
        case "se":
            df = ["yyyy-MM-dd", "yyyyMMdd", "yy-MM-dd", "yyMMdd"];
            break;
        case "fi":
            df = ["d.M.yyyy", "dMyyyy", "d.M.yy", "dMyy"];
            break;
        case "gb":
            df = ["MM/dd/yyyy", "MMddyyyy", "M/d/yy", "MMddyy"];
            break;
        default:
            df = ["yyyy-MM-dd", "yyyyMMdd", "yy-MM-dd", "yyMMdd"];
    }
    return df;
};

export const formatDate = (date) => {
    const country = getCookie("App.CultureCode");
    const defaultLanguage = defaultLanguageSwitch(country.toUpperCase());
    if (date instanceof Date && isValid(date)) {
        let formatedDate = date.toLocaleDateString(
            `${defaultLanguage}-${country}`,
        );
        if (/[,\-]/.test(formatedDate)) {
            formatedDate = replaceWithNonBreakingHyphens(formatedDate);
        }
        return formatedDate;
    }

    if (isValid(parseISO(date))) {
        let formatedDate = parseISO(date).toLocaleDateString(
            `${defaultLanguage}-${country}`,
        );
        if (/[,\-]/.test(formatedDate)) {
            formatedDate = replaceWithNonBreakingHyphens(formatedDate);
        }
        return formatedDate;
    }
};

export const formatShortDate = (barCharData) => {
    for (const prop in barCharData) {
        if (Object.prototype.hasOwnProperty.call(barCharData, prop)) {
            const c = prop.toString();
            const year = c.substr(0, 4);
            let month = c.substr(5, 2);
            const country = getCookie("App.CultureCode");
            switch (country) {
                case "SE":
                    barCharData[`${year}-${month}`] = barCharData[prop];
                    break;
                case "FI":
                    const fiMonth = parseInt(month);
                    month = fiMonth.toString();
                    barCharData[`${month}.${year}`] = barCharData[prop];
                    delete barCharData[prop];
                    break;
                case "GB":
                    barCharData[`${year}/${month}`] = barCharData[prop];
                    delete barCharData[prop];
                    break;
                default:
            }
        }
    }
    return barCharData;
};

export const removeTimeFromDate = (date) => {
    if (date instanceof Date && isValid(date)) {
        return new Date(date.toDateString());
    }
    return date;
};

export const formatDateAndTime = (date) =>
    isValid(parseISO(date))
        ? replaceWithNonBreakingHyphens(
              format(parseISO(date), "yyyy-MM-dd HH:mm"),
          )
        : date;

export const formatAmount = (amount, decimals = 2) =>
    currencyFormatter(amount, decimals);

export const camelCase = (str) =>
    str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
        if (+match === 0) return "";
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });

export const camelizeKeys = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map((v) => camelizeKeys(v));
    }
    if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce(
            (result, key) => ({
                ...result,
                [camelCase(key)]: camelizeKeys(obj[key]),
            }),
            {},
        );
    }
    return obj;
};
